import type { NotificationDto, NotificationType } from '../../shared/api/types'

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  // Старые типы — новые уведомления этих типов с 30.04 не создаются,
  // но в БД могут быть исторические записи. Поэтому подписи оставлены.
  PROCUREMENT_QUOTE_ADDED: 'Квота',
  PROCUREMENT_QUOTES_BULK_ADDED: 'Квоты',
  REQUEST_PROCUREMENT_COMPLETED: 'Просчёт',
  QUOTE_COMMENT_ADDED: 'Комментарий к квоте',
  COMMENT_MENTION: '@ упоминание',
  COMMENT_REPLY: 'Ответ на комментарий',
  REQUEST_ITEM_COMMENT_ADDED: 'Комментарий к позиции',
  REQUEST_COMMENT_ADDED: 'Комментарий к заявке',
  CLIENT_CREATED: 'Новый клиент',
  REQUEST_CREATED: 'Новая заявка',
  REQUEST_CLOSED: 'Заявка закрыта',
  REQUEST_SENT_TO_PROCUREMENT: 'Новая заявка в закупке',
  NEWS_POSTED: 'Новость компании',
  CLIENT_OWNER_REASSIGNED: 'Смена владельца клиента',
  // Блок 2 «Заказы»
  ORDER_CREATED: 'Создан заказ',
  ORDER_NEEDS_ROP_APPROVAL: 'Заказ ждёт согласования',
  ORDER_APPROVED: 'Заказ подтверждён',
  ORDER_PAYMENT_RECEIVED: 'Оплата по заказу',
  ORDER_CLOSED: 'Заказ закрыт',
  // Нетарифка (логист, с 25.09.2026)
  CUSTOMS_ANSWERED: 'Нетарифка: ответ получен',
  CUSTOMS_ATTENTION: 'Нетарифка: внимание',
  CUSTOMS_NEEDS_INFO: 'Нетарифка: нужна информация',
}

type NotificationMeta = {
  route?: string
  requestId?: string
  requestItemId?: string
  quoteId?: string | null
  commentId?: string | null
}

export function getNotificationMeta(notification: NotificationDto): NotificationMeta {
  if (notification.meta && typeof notification.meta === 'object') {
    return notification.meta as NotificationMeta
  }
  return {}
}

export function getNotificationRoute(notification: NotificationDto): string {
  const meta = getNotificationMeta(notification)
  if (meta.route) return meta.route
  if (notification.requestId) {
    const params = new URLSearchParams()
    if (notification.requestItemId) params.set('itemId', notification.requestItemId)
    if (notification.quoteId) {
      params.set('focus', 'quote')
      params.set('quoteId', notification.quoteId)
    }
    if (notification.commentId) {
      params.set('focus', 'comment')
      params.set('commentId', notification.commentId)
    }
    const qs = params.toString()
    return `/requests/${notification.requestId}${qs ? `?${qs}` : ''}`
  }
  return '/notifications'
}

export function formatNotificationDate(value: string): string {
  return new Date(value).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}
